<h1 mat-dialog-title class="text-center">Aumentar Tiempo</h1>
<div mat-dialog-content>
  <p>&iquest;Cu&aacute;nto tiempo desea aumentar a la pregunta?</p>
  <mat-form-field appearance="fill" class="timer-ripple-form-field">
    <input matInput [(ngModel)]="data.tiempoAdicional" type="number" placeholder="MM">
    <mat-icon matSuffix>alarm_add</mat-icon>
    <mat-hint>Tiempo en Minutos.</mat-hint>
  </mat-form-field>
</div>
<div mat-dialog-actions class="d-flex justify-content-center">
  <button mat-raised-button (click)="onNoClick()" class="text-danger">Cancelar</button>
  <button mat-raised-button [mat-dialog-close]="data.tiempoAdicional" cdkFocusInitial color="primary">Aumentar</button>
</div>